import { AxiosError } from 'axios';
import { push } from 'connected-react-router';

import { getLoggedRole, logout } from 'data-layer-cr/dist/authentication';

import store from '../store';
import {
  updateProfileData,
  updateLicenses,
} from '../store/profile/slice/profileSlice';
import resetCreationFormValues from '../store/quotation/actions/resetCreationFormValues';

/**
 * Checks if the error response contains an unauthorized status, and if true:
 * - forces a logout, cleaning the session.
 * - forcefully redirects the user to the login screen.
 *
 * @param error - The error reported by axios
 */
export default function injectUnauthorizedLogout(error: AxiosError): void {
  if (error && error.response) {
    if (error.response.status === 401) {
      /** Remove the session */
      const authType = getLoggedRole();
      logout();

      /** Remove identifying data */
      store.dispatch(updateProfileData(null));
      store.dispatch(updateLicenses([]));

      /** Redirect */
      store.dispatch(push(`/${authType}/login`));

      /** This will prevent the previous from from polluting the next session */
      store.dispatch(resetCreationFormValues());
    }
  }
}
